import React from 'react';
import Card from '../edit-page/Card';

export default class HomeLastEdit extends React.Component {
    render() {
        return (
            <div className="home-last-edit">
                <Card label={this.props.title}>
                    <div className="small-table last-edit-table">
                        <table>
                            <thead>
                            <tr>
                                <th>{__('Name')}</th>
                                <th>{__('Modification date')}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.items.map((item, index) => (
                                <tr key={index}>
                                    <td><a className="link" href={item.url}>{item.name}</a></td>
                                    <td>{item.date}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </Card>
            </div>

        )
    }
}